import React from "react";

export default function BlogContent({ blog }) {
  const html = blog?.content_html || "<p>Konten artikel belum tersedia.</p>";

  return (
    <article className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      {blog?.featured_image ? (
        <img
          src={blog.featured_image}
          alt={blog?.cover_alt || blog?.title}
          className="aspect-[16/8] w-full object-cover"
        />
      ) : null}

      <div className="p-6 md:p-8">
        <div className="mb-6 flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-full bg-orange-50 px-2.5 py-1 font-medium text-orange-700">
            {blog?.category_name || "Artikel"}
          </span>
          <span className="text-gray-400">•</span>
          <span className="text-gray-500">{blog?.author_name || "Admin"}</span>
          {blog?.reading_time ? (
            <>
              <span className="text-gray-400">•</span>
              <span className="text-gray-500">{blog.reading_time}</span>
            </>
          ) : null}
        </div>

        <div
          className="prose prose-gray max-w-none prose-headings:scroll-mt-24 prose-a:text-orange-600"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </article>
  );
}
